import React from "react";
import withStyles from "react-jss";

const styles = theme => {
    return {
        root: {
            margin: 0,
            display: "flex",
            alignItems: "flex-start",
            width: "900px",
            listStyle: "none",
            padding: 0,
        },
        [`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
            root: {
                width: "640px",
            },
        },
        [`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
            root: {
                width: "100%",
            },
        },
        [`@media (max-width: ${theme.media.sm})`]: {
            root: {
                width: "100%",
                flexWrap: "wrap",
            },
        },
    };
};

class FooterMenu extends React.Component {
    render() {
        let classes = this.props.classes;
        return <div className={classes.root}>{this.props.children}</div>;
    }
}

export default withStyles(styles)(FooterMenu);
